var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocalComputerAdminStatsSection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "4zo9t4gbda",
    d: "M0 0h8.407v9.629H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "adozqlaapc",
    d: "M0 0h7.3v7.306H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.488 15.303.545-.546c.273-.273.63-.42 1.007-.42.147 0 .273.021.399.063.168-.315.44-.546.776-.65a5.127 5.127 0 0 0-2.706-2.436 4.815 4.815 0 0 1-3.357 1.386 4.815 4.815 0 0 1-3.356-1.386A5.119 5.119 0 0 0 4.502 16.1v1.805c0 .294.252.546.546.546h8.349v-.504c0-.525.294-1.008.734-1.26a1.49 1.49 0 0 1 .357-1.385z",
    fill: "#0058AB"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.944 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "2uiqqb4hmb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4zo9t4gbda"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.502 5.535a.242.242 0 0 0 .252-.252c-.084-.63-.189-2.205.357-2.058.692.168 1.447.378 2.119.378.67 0 1.426-.21 2.118-.378.546-.147.42 1.428.357 2.058-.021.147.105.252.252.252l.23-.021c-.042 1.763-1.342 3.17-2.937 3.17-1.594 0-2.895-1.407-2.936-3.17l.188.02zM.307 5.409c0 2.33 1.762 4.22 3.902 4.22 2.16 0 3.902-1.89 3.902-4.22 0-.231 0-.441-.021-.672.63-1.848.314-5.207-.881-4.682C6.18.517.474-.932.81 1.483-.532 1.525.16 4.17.328 4.737c-.021.23-.021.44-.021.672z",
    fill: "#0058AB",
    mask: "url(#2uiqqb4hmb)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.446 14.694)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "0epye4w6ld",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#adozqlaapc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.629 4.934c-.713 0-1.28-.567-1.28-1.281s.567-1.28 1.28-1.28c.713 0 1.28.566 1.28 1.28.02.693-.567 1.28-1.28 1.28zm3.315-2.037-.65-.105c-.085-.21-.106-.252-.19-.462l.4-.525a.353.353 0 0 0-.043-.461L5.916.798a.352.352 0 0 0-.462-.042l-.524.399c-.21-.084-.252-.105-.462-.19l-.105-.65A.363.363 0 0 0 4.007 0H3.23a.36.36 0 0 0-.357.315l-.105.65c-.21.085-.252.106-.462.19L1.804.777a.352.352 0 0 0-.462.042l-.545.546a.353.353 0 0 0-.042.462l.399.524c-.084.21-.105.252-.19.462l-.65.105A.363.363 0 0 0 0 3.275v.777a.36.36 0 0 0 .315.357l.65.105c.084.21.105.252.189.462L.755 5.5a.353.353 0 0 0 .042.461l.545.546a.352.352 0 0 0 .462.042l.524-.399c.21.084.252.105.462.19l.105.65a.363.363 0 0 0 .356.315h.777a.36.36 0 0 0 .356-.315l.105-.65c.21-.085.252-.106.462-.19l.524.4a.352.352 0 0 0 .462-.043l.545-.546a.353.353 0 0 0 .042-.461l-.399-.546c.084-.21.105-.252.19-.462l.67-.105A.363.363 0 0 0 7.3 4.03v-.777a.476.476 0 0 0-.356-.357z",
    fill: "#368DC5",
    mask: "url(#0epye4w6ld)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalComputerAdminStatsSection);
export default __webpack_public_path__ + "static/media/local-computer-admin-stats-section.5ac43dbe.svg";
export { ForwardRef as ReactComponent };